<template>
  <v-card height="250">
    <v-card-title class="text-h5 grey lighten-2">
      Associate Record
    </v-card-title>

    <v-card-text
      >Choose a record from the dropdown to associate with
      {{ user.account_name }}</v-card-text
    ><v-autocomplete
      auto-select-first
      :loading="!nodesLoaded"
      :disabled="!nodesLoaded"
      :items="records"
      item-text="name"
      item-value="_id"
      attach
      clear-icon="mdi-close-circle"
      clearable
      @click:clear="clear"
      hide-selected
      label="Select Record"
      class="mx-6"
      v-model="selectedRecord"
      :search-input.sync="theRec"
      return-object
      ref="recordSelect"
    >
      <template v-slot:selection="{ attr, on, item, selected }">
        <v-chip
          v-bind="attr"
          :input-value="selected"
          color="#78909c"
          class="white--text"
          v-on="on"
        >
          <v-icon left>mdi-coin</v-icon>
          <span v-text="item.name"></span>
        </v-chip>
      </template>
    </v-autocomplete>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="associateUser()" color="primary">
        Associate Record
      </v-btn>
      <v-btn @click="closeDialog()" color="primary">
        Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { strings } from "vuex-store-builder";
import { COLLECTIONS } from "../urls";
export default {
  props: {
    user: Object
  },
  computed: {
    ...mapState("allRootNodes", { nodesLoaded: strings.loaded("nodes") }, ""),
    ...mapGetters("allRootNodes", { records: "list" })
  },
  data() {
    return {
      theRec: null,
      selectedRecord: {}
    };
  },
  methods: {
    clear() {
      this.selectedRecord = null;
    },
    associateUser() {
      this.$store
        .dispatch("associateRecord", {
          username: this.user.account_name,
          record_collection: COLLECTIONS.RECORDS,
          record_id: this.selectedRecord._id
        })
        .then(() => {
          this.closeDialog();
        });
    },
    closeDialog() {
      this.$emit("closedialog2");
    }
  }
};
</script>

<style></style>
